export default __webpack_public_path__ + "static/media/menu-icon.68a33f41.svg";